import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { usePermissions } from './usePermissions';
import { useAuth } from './useAuth';

interface Props {
  children: ReactNode;
}

/**
 * RequireSuperAdmin — гейт для dev-only страниц (/dev/*).
 * Редиректит обычных пользователей на /sites. Используется поверх RequireAuth.
 */
export function RequireSuperAdmin({ children }: Props) {
  const { isLoading } = useAuth();
  const { isSuperAdmin } = usePermissions();

  if (isLoading) {
    return (
      <div style={{ minHeight: '50vh', display: 'grid', placeItems: 'center', color: '#683DFF' }}>
        Загрузка…
      </div>
    );
  }

  if (!isSuperAdmin) {
    return <Navigate to="/sites" replace />;
  }

  return <>{children}</>;
}
